<template lang="pug">
    div
        a(@click.prevent="goToRoute" :href="href" v-if="routeParams.name && !isCurrentRoute")
            slot
        span(v-else)
            slot
</template>
<script>
export default {
    name: "LinkExtend",
    props: {
        routeParams: {
            type: Object,
            default: () => ({
                name: "",
                params: "",
                query: {},
            }),
        },
    },
    methods: {
        goToRoute() {
            this.$router.replace(this.routeParams);
        },
    },
    computed: {
        href() {
            return this.$router.resolve(this.routeParams).href;
        },
        isCurrentRoute() {
            return this.$route.fullPath == this.href;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/LinkExtend.vue